/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Lock_Lost_WarningInputs */



/**
* | output |
* | --- |
* | "An organizer ended this tournament's offline session (unlocked or took it over). Your offline changes couldn't be saved." |
*
* @param {Offline_Lock_Lost_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_lock_lost_warning = /** @type {((inputs?: Offline_Lock_Lost_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Lock_Lost_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un organisateur a mis fin à la session hors ligne de ce tournoi (déverrouillage ou prise de main). Vos modifications hors ligne n'ont pas pu être enregistrées.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Un organizador terminó la sesión sin conexión de este torneo (desbloqueo o toma de control). Sus cambios sin conexión no se pudieron guardar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um organizador encerrou a sessão offline deste torneio (desbloqueio ou assumiu o controle). Suas mudanças offline não puderam ser salvas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un organizzatore ha chiuso la sessione offline di questo torneo (sblocco o presa di controllo). Le tue modifiche offline non sono state salvate.")
	return /** @type {LocalizedString} */ ("An organizer ended this tournament's offline session (unlocked or took it over). Your offline changes couldn't be saved.")
});